<template>
  <div class="dg__list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "dg-list",
  data() {
    return {};
  },
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    inlineWidth: {
      type: String,
      default: "250"
    },
    labelSuffix: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "80"
    },
    labelClass: String,

    margin: {
      type: Array,
      default: () => {
        return [];
      }
    },
    size: String,
    color: String
  }

};
</script> <style></style>